import { render, staticRenderFns } from "./kng-upload-tips.vue?vue&type=template&id=0c251745"
import script from "./kng-upload-tips.vue?vue&type=script&lang=js"
export * from "./kng-upload-tips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports